module.exports = __webpack_public_path__ + "img/ic_actual revenue_blue.c68ec639.svg";